<template>
    <div
        class="layout-cards grid grid-cols-1 gap-x-3.5 gap-y-12 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5"
    >
        <layout-card
            v-for="(card, index) in cards"
            :class="hideServer(index)"
            :key="'layout-cards-' + index"
            :route="card.route"
            :image="card.image"
            :imageSet="card.imageSet"
            :imageSizes="card.imageSizes"
            :imageAlt="card.imageAlt"
            :imageAspectRatio="card.imageAspectRatio"
            :imageObjectFit="card.imageObjectFit"
            :imageObjectPosition="card.imageObjectPosition"
            :imageLoading="contentful && index === 0 ? 'eager' : card.imageLoading"
            :imagePriority="contentful && index === 0 ? 'high' : card.imagePriority"
            :heading="card.heading"
            :excerpt="card.excerpt"
        ></layout-card>
    </div>
</template>

<script>
export default {
    name: 'LayoutCards',
    props: {
        cards: {
            required: false,
            type: Array,
            default() {
                return [];
            },
        },
        contentful: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
        truncated: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
    },
    methods: {
        hideServer(index) {
            if (!this.truncated) return '';
            if (index === 0) return '';
            if (index === 1) return 'hidden sm:block';
            if (index === 2) return 'hidden md:block';
            if (index === 3) return 'hidden lg:block';
            if (index === 4) return 'hidden 2xl:block';
            if (index > 4) return 'hidden';
        },
    },
};
</script>
